import React from "react";
import { Link } from "react-router-dom";

const KycPolicy = () => {
  return (
    <>
      {/* Custom Cursors */}
      <div className="custom-cursor-one"></div>
      <div className="custom-cursor-two"></div>

      {/* inner-page hero */}
      <div
        className="inner-page-hero"
        style={{ backgroundImage: "url(/assets/images/background/bg3.png)" }}
      >
        <div className="container">
          <div className="hero-heading-title">
            <h2>KYC Policy</h2>
          </div>
          <ul className="bradcrumb">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <Link to="#">Kyc Policy</Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Main Section */}
      <section className="privacy-section">
        <div className="container">
          <div className="row justify-content-center">

            <div className="col-lg-12">
              <div className="privacy-content-card">

                {/* Header */}
                <div className="mb-5 text-center">
                  <span className="heading-subtitle wow fadeInUp animated">
                    🔐 KYC Policy
                  </span>

                  <h2 className="wow fadeInUp animated">
                    Wall Street Finz — Know Your Customer Policy
                  </h2>

                  <div className="meta-info-box">
                    <p>
                      <strong>Effective Date:</strong> Immediately upon
                      publication
                    </p>

                    <p>
                      <strong>Compliance:</strong> RBI KYC Guidelines |
                      Prevention of Money Laundering Act, 2002
                    </p>
                  </div>

                  <p className="intro-text mt-4">
                    Wall Street Finz is committed to maintaining the highest
                    standards of Customer Due Diligence (CDD) as mandated by
                    regulatory authorities. This KYC Policy outlines our
                    procedures for identity verification, document collection,
                    and ongoing monitoring to prevent financial fraud and
                    ensure secure lending practices.
                  </p>
                </div>

                <hr className="divider" />

                {/* 1 Mandatory Documents */}
                <div className="policy-block">
                  <h3>1. Mandatory KYC Documents</h3>

                  <p>
                    All individual loan applicants must submit the following
                    documents for identity and address verification.
                  </p>

                  <div className="info-grid">

                    <div className="info-card">
                      <h4>PAN Card</h4>
                      <ul>
                        <li>Purpose: Income Tax Identification</li>
                        <li>Status: Mandatory</li>
                        <li>Verification: NSDL Verification</li>
                      </ul>
                    </div>

                    <div className="info-card">
                      <h4>Aadhaar Card</h4>
                      <ul>
                        <li>Purpose: Identity & Address Proof</li>
                        <li>Status: Mandatory</li>
                        <li>Verification: UIDAI QR Verification</li>
                      </ul>
                    </div>

                    <div className="info-card">
                      <h4>Passport</h4>
                      <ul>
                        <li>Purpose: Identity Proof</li>
                        <li>Status: Optional</li>
                        <li>Verification: MRZ Code Check</li>
                      </ul>
                    </div>

                    <div className="info-card">
                      <h4>Driving License</h4>
                      <ul>
                        <li>Identity & Address Proof</li>
                        <li>Status: Optional</li>
                        <li>Verification: RTO Database</li>
                      </ul>
                    </div>

                    <div className="info-card">
                      <h4>Voter ID Card</h4>
                      <ul>
                        <li>Purpose: Identity Proof</li>
                        <li>Status: Optional</li>
                        <li>Verification: ECI Database</li>
                      </ul>
                    </div>

                  </div>

                  <div className="alert-box warning mt-3">
                    Aadhaar Security Note: First 8 digits of Aadhaar are
                    masked/redacted in our records as per RBI guidelines.
                    Digital KYC is conducted only with customer consent.
                  </div>
                </div>

                {/* 2 Address Proof */}
                <div className="policy-block">
                  <h3>2. Additional Address Proof (Deemed OVDs)</h3>

                  <p>
                    If the primary OVD does not contain the current address,
                    we may accept the following:
                  </p>

                  <div className="info-grid">

                    <div className="info-card">
                      <h4>Utility Bills</h4>
                      <ul>
                        <li>Electricity Bill</li>
                        <li>Telephone Bill</li>
                        <li>Water Bill</li>
                        <li>Gas Connection Bill</li>
                        <li>Validity: Not older than 2 months</li>
                      </ul>
                    </div>

                    <div className="info-card">
                      <h4>Bank Documents</h4>
                      <ul>
                        <li>Bank Account Statement</li>
                        <li>Passbook with Address</li>
                        <li>Post Office Statement</li>
                        <li>Issued within 3 months</li>
                      </ul>
                    </div>

                    <div className="info-card">
                      <h4>Government Issued</h4>
                      <ul>
                        <li>Property Tax Receipt</li>
                        <li>Municipal Tax Receipt</li>
                        <li>Pension Payment Order (PPO)</li>
                        <li>Employer Allotment Letter</li>
                      </ul>
                    </div>

                  </div>
                </div>

                {/* 3 Business Entity KYC */}
                <div className="policy-block">
                  <h3>3. Business Entity KYC Requirements</h3>

                  <div className="info-grid">

                    <div className="info-card">
                      <h4>Sole Proprietorship</h4>
                      <ul>
                        <li>Udyam Registration Certificate</li>
                        <li>Shop & Establishment License</li>
                        <li>GST Certificate</li>
                        <li>Proprietor Individual KYC</li>
                        <li>Bank Statement (Last 6 months)</li>
                      </ul>
                    </div>

                    <div className="info-card">
                      <h4>Private/Public Limited Company</h4>
                      <ul>
                        <li>Certificate of Incorporation</li>
                        <li>Memorandum & Articles of Association</li>
                        <li>Company PAN Card</li>
                        <li>Board Resolution</li>
                        <li>Director KYC Documents</li>
                      </ul>
                    </div>

                    <div className="info-card">
                      <h4>Partnership Firm</h4>
                      <ul>
                        <li>Partnership Deed</li>
                        <li>Registration Certificate</li>
                        <li>Firm PAN Card</li>
                        <li>KYC of All Partners</li>
                      </ul>
                    </div>

                  </div>
                </div>

                {/* 4 Verification Process */}
                <div className="policy-block">
                  <h3>4. KYC Verification Process</h3>

                  <div className="info-grid">

                    <div className="info-card">
                      <h4>Document Upload</h4>
                      <p>Submit clear copies via app or portal.</p>
                      <p className="small text-muted">Instant</p>
                    </div>

                    <div className="info-card">
                      <h4>Automated Validation</h4>
                      <p>AI-powered document verification.</p>
                      <p className="small text-muted">2–5 minutes</p>
                    </div>

                    <div className="info-card">
                      <h4>Face Match & Liveness</h4>
                      <p>Selfie verification against photo ID.</p>
                      <p className="small text-muted">1–2 minutes</p>
                    </div>

                    <div className="info-card">
                      <h4>Central KYC (CKYC)</h4>
                      <p>Registration with Central Registry.</p>
                      <p className="small text-muted">24–48 hours</p>
                    </div>

                  </div>
                </div>

                {/* 5 Security */}
                <div className="policy-block">
                  <h3>5. Data Security & Retention</h3>

                  <div className="security-features">

                    <span className="sec-tag">
                      End-to-End Encryption (256-bit SSL)
                    </span>

                    <span className="sec-tag">
                      ISO 27001 Secure Servers
                    </span>

                    <span className="sec-tag">
                      Security Audits
                    </span>

                    <span className="sec-tag">
                      Secure Document Storage
                    </span>

                  </div>

                  <p className="mt-3">
                    KYC documents are retained for <strong>10 years</strong> after
                    account closure as per PMLA guidelines.
                  </p>

                  <p>
                    Customers must update KYC within <strong>30 days</strong> of
                    any document change.
                  </p>
                </div>

                {/* Contact */}
                <div className="contact-block">
                  <h3>Contact Us</h3>
                  <p>
                    For questions, concerns, or requests related to KYC or
                    privacy:
                  </p>

                  <div className="contact-details">
                    <div className="contact-row">
                      <i className="flaticon-email"></i>
                      <a href="mailto:info@wallstreetfinz.com">
                        info@wallstreetfinz.com
                      </a>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default KycPolicy;